<template>
  <nav class="admin-nav mb-4">
    <div class="nav nav-tabs">
      <router-link 
        class="nav-link" 
        :class="{ active: isActive('/admin/tenants') }"
        to="/admin/tenants"
      >
        <Building :size="18" class="me-2" />
        Tenants
      </router-link>
      <router-link 
        class="nav-link" 
        :class="{ active: isActive('/admin/roles') }"
        to="/admin/roles"
      >
        <Shield :size="18" class="me-2" />
        Roles & Claims
      </router-link>
      <router-link 
        class="nav-link" 
        :class="{ active: isActive('/admin/migrations') }"
        to="/admin/migrations"
      >
        <Database :size="18" class="me-2" />
        Migrations
      </router-link>
      <router-link 
        class="nav-link" 
        :class="{ active: isActive('/admin/logs') }"
        to="/admin/logs"
      >
        <FileText :size="18" class="me-2" />
        System Logs
      </router-link>
      <router-link 
        class="nav-link" 
        :class="{ active: isActive('/admin/email') }"
        to="/admin/email/settings"
      >
        <Mail :size="18" class="me-2" />
        Email
      </router-link>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { Building, Shield, Database, FileText, Mail } from 'lucide-vue-next';

const route = useRoute();

const isActive = (path: string) => {
  return route.path.startsWith(path);
};
</script>

<style scoped>
.admin-nav {
  background-color: #fff;
  border-radius: 8px;
  padding: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.admin-nav .nav-link {
  color: #495057;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1.25rem;
  margin-right: 0.25rem;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
}

.admin-nav .nav-link:hover {
  background-color: #f8f9fa;
  color: #132341;
}

.admin-nav .nav-link.active {
  background-color: #132341;
  color: #fff;
}

.admin-nav .nav-link.active:hover {
  background-color: #1a3a5c;
  color: #fff;
}
</style>
